export default __webpack_public_path__ + "static/media/top_performer (2).547c5385.png";